<template>
    <div class="aui-searchbar search-box" :class="{'fixed':isfixed==true,'absolute':isabsolute==true}" @click.stop="">
        <div class="aui-searchbar-input aui-border-radius">
            <i class="el-icon-search" />
            <input v-model="value" type="search" :placeholder="'过滤'+caption" @keyup.13="oninputfinish">
            <div v-if="showscan" class="aui-searchbar-clear-btn" style="right:40px" @click="scan">
                <i class="el-icon-camera" />
            </div>
            <div v-if="showextratext" class="aui-searchbar-clear-btn" :style="{right:15*extratext.length+'px'}" @click="clickextra">
                {{ extratext }}
            </div>
            <div class="aui-searchbar-clear-btn">
                <span @click="clicksearch">搜索</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'wxl-search-box',
        data: function() {
            return {
                value: '',
                timeoutuid: 0
            }
        },
        props: {
            caption: {
                type: String,
                default: ''
            },
            isfixed: Boolean,
            isabsolute: Boolean,
            showscan: Boolean,
            showextratext: Boolean,
            extratext: String,
            onlybytapsearch: Boolean, // 只有主动点击搜索才行
            clicksearchmethod: {
                type: String,
                default: 'search'
            }
        },
        methods: {
            setinputvalue: function(value) {
                this.value = value
            },
            oninputfinish: function() {
                var that = this
                clearTimeout(this.timeoutuid)
                this.timeoutuid = setTimeout(function() {
                    that.$emit('search', that.value)
                }, 300)
            },
            search: function() {
                this.$emit('search', this.value)
            },
            clicksearch: function() {
                this.$emit(this.clicksearchmethod, this.value)
            },
            scan: function() {
                this.$emit('scan')
            },
            clickextra: function() {
                this.$emit('clickextra')
            }
        },
        watch: {
            value: function() {
                var that = this
                if (this.onlybytapsearch === true) {
                    return
                }
                clearTimeout(this.timeoutuid)
                this.timeoutuid = setTimeout(function() {
                    that.search()
                }, 300)
            }
        }
    }
</script>
<style lang="less" scoped>
    @import '@/styles/position.less';
    .fixed{
        .fixed();
        z-index: 99;
        background:#ebeced;
    }
    .absolute{
        position: absolute;
    }
    .aui-searchbar {
        display: -webkit-box;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 44px !important;
        background: #ebeced;
        .aui-searchbar-input {
            margin: 0 8px;
            padding-left: 8px;
            border-radius: 4px;
            height: 28px;
            line-height: 28px;
            background-color: #ffffff;
            display: -webkit-box;
            -webkit-box-flex: 1;
            width: 100%;
            .icon-chaxun {
                line-height: 28px;
                margin-right: 5px;
                color: #9e9e9e !important;
            }
            input {
                border: none;
                outline: none;
                position: absolute;
                top: 8px;
                height: 28px;
                left: 36px;
                line-height: 28px;
                width: calc(100% - 92px);
            }
            .aui-searchbar-clear-btn {
                position: absolute;
                right: 8px;
                width: 56px;
                height: 28px;
                line-height: 28px;
                color: rgb(3,169,244);
                top: 8px;
                font-size: 14px;
                font-weight: 600;
                display: block;
                text-align: center;
                user-select: none;
                cursor: pointer;
            }
        }
    }
</style>
